<template>
    <ReportingLayout>
      <Logo />

      <h2>{{ $t("title") }}</h2>

      <br />

      <h5>{{ $t("info") }}</h5>

      <br />
      
      <div v-for="feedback, index in feedbacks" :key="feedback.id">
        {{ index + 1 }}.<br/>
        <strong>{{ $t("openfeedback") }}</strong> {{ feedback.open_feedback }}<br/>
        <strong>{{ $t("learn") }}</strong> {{ feedback.what_did_i_learn }}<br/>
        <strong>{{ $t("recommend") }}</strong> <span v-if="feedback.nps_answer > 0">{{ feedback.nps_answer }}</span><br/>
        <br/>
    </div>
  </ReportingLayout>
</template>

<script>
import {
  getFeedbackByGameCode,
} from "../services/APIService";
import ReportingLayout from "@/layouts/ReportingLayout.vue";
import Logo from "@/components/Logo.vue";

export default {
  components: {
    ReportingLayout,
    Logo
  },
  data: function () {
    return {
      feedbacks: [],
    };
  },
  async mounted() {
    this.feedbacks = await getFeedbackByGameCode(this.$route.params.gamecode);
  },
};
</script>

<i18n>
{
  "en": {
    "title": "Received feedback",
    "info": "Participants can give feedback using the feedback form on the report page. Feedback can be given both immediately after the simulation and later. This page must be refreshed for new feedback to appear.",
    "openfeedback": "Open feedback about the simulation tool:",
    "learn": "What did you learn in the simulation?",
    "recommend": "How likely is it that you would recommend this tool to a friend or colleague? ",
    "submit": "Submit",
    "thankyou": "Thank you!"
  },
  "fi": {
    "title": "Simulaatiosta saatu palaute",
    "info": "Osallistujat voivat antaa palautetta raporttisivulla olevalla palautelomakkeella. Palautetta voi antaa sekä heti simulaation jälkeen että myöhemmin. Tämä sivu on päivitettävä, jotta uudet palautteet tulevat näkyviin.",
    "openfeedback": "Avointa palautetta simulaatiosta",
    "learn": "Mitä opit simulaatiossa?",
    "recommend": "Kuinka todennäköisesti suosittelisit simulaatiota ystävällesi tai työkaverillesi? ",
    "submit": "Lähetä",
    "thankyou": "Kiitos!"
  },
  "sv": {
    "title": "Mottagen feedback",
    "info": "Deltagarna kan ge feedback med hjälp av feedbackformuläret på rapportsidan. Feedback kan ges både direkt efter simuleringen och senare. Den här sidan måste uppdateras för att ny feedback ska visas.",
    "openfeedback": "Öppna feedbackformuläret om simuleringsverktyget",
    "learn": "Vad lärde du dig under simuleringen?",
    "recommend": "Hur sannolikt är det att du skulle rekommendera detta verktyg till en vän eller kollega? ",
    "submit": "Slutför",
    "thankyou": "Tack för hjälpen"
  },
  "de": {
    "title": "Erhaltene Feedback",
    "info": "Teilnehmer können über das Feedback-Formular auf der Berichtsseite Feedback geben. Feedback kann sowohl unmittelbar nach der Simulation als auch später gegeben werden. Diese Seite muss aktualisiert werden, damit neues Feedback angezeigt wird.",
    "openfeedback": "Offenes Feedback zum Simulationswerkzeug",
    "learn": "Was hast du in der Simulation gelernt?",
    "recommend": "Wie wahrscheinlich ist es, dass Sie dieses Tool einem Freund oder Kollegen empfehlen? ",
    "submit": "Einreichen",
    "thankyou": "Vielen Dank!" 
  },
  "ko": {
      "title": "피드백 설문",
      "info": "참가자는 보고서 페이지의 피드백 양식을 사용하여 피드백을 제공할 수 있습니다. 피드백은 시뮬레이션 직후와 나중에 모두 제공될 수 있습니다. 새 피드백을 표시하려면 이 페이지를 새로 고쳐야 합니다.",
      "openfeedback": "시뮬레이션에 대한 피드백을 자유롭게 남겨주세요.",
      "learn": "이 과정을 통해 무엇을 배우셨습니까?",
      "recommend": "시뮬레이션을 친구 혹은 동료에게 추천하시겠습니까? ",
      "submit": "제출",
      "thankyou": "감사합니다."
  }  
}
</i18n>
